import {entityAdmin, projectOwner, userContact, dashboardViews} from '../../../../../../../util/uiconstants';

const getFilteredContacts = (contacts, users, operation, userLevelAccess) => {
	if (operation === undefined ) {
		return contacts?.map((contact) => {
			const userFound = users.find((user) => user.userId === contact.userId);
			if (userFound) {
				return {...contact, ...userFound};
			}
			return contact;
		});
	}

	// If operation is true and userLevelAccess is projectOwner, then add the list of users to the contacts of entity.root (at index 0) as owner.
	if (operation && userLevelAccess === projectOwner) {
		contacts = contacts.map(contact => {
			const user = users.find(user => user.userId === contact.userId);
			if (user) {
				return {
					...user,
					isProjectOwner: true,
					dashboard: [
						dashboardViews.milestones,
						dashboardViews.ccp,
						dashboardViews.groupAudit,
						dashboardViews.projectManagement,
						dashboardViews.insights,
						dashboardViews.reporting
					],
					contactList: {hasAccess: true}
				};
			}
			return contact;
		});
	
		users.forEach(user => {
			if (!contacts.some(contact => contact.userId === user.userId)) {
				contacts.push({...user, isProjectOwner: true, dashboard: [
					dashboardViews.milestones,
					dashboardViews.ccp,
					dashboardViews.groupAudit,
					dashboardViews.projectManagement,
					dashboardViews.insights,
					dashboardViews.reporting
				], contactList: {hasAccess: true}});
			}
		});
	
		return contacts;
	}

	// If operation is false and userLevelAccess is projectOwner, then remove the list of users from the contacts of entity.root (at index 0) as owner
	// and works when user is moved by entities
	if (operation === false && (userLevelAccess === projectOwner || userLevelAccess === userContact || userLevelAccess === entityAdmin)) {
		return contacts.filter((contact) => !users.some((user) => user.userId === contact.userId));
	}

	if (operation && (userLevelAccess === userContact || userLevelAccess === entityAdmin)) {
		contacts = [...contacts, ...users];
		return contacts;
	}
};

const handleEntityOperation = (users, entityList, entityData, userLevelAccess) => {
	let updatedEntityList = entityList.map((entity) => {
		if (entity.entityId === entityData.entityId) {
			return {...entity, contacts: getFilteredContacts(entity.contacts, users, entityData?.operation, userLevelAccess)};
		}
		return {...entity};
	});

	//it checks if it is the operation to add owners to the entity is true and the userLevelAccess is projectOwner, removes the users as admins list
	// it applies if the operation undefined and the userLevelAccess is users
	if (
		(entityData?.operation && userLevelAccess === projectOwner) ||
		(entityData?.operation === undefined && userLevelAccess === userContact)
	) {
		updatedEntityList = updatedEntityList.map((entity) => ({
			...entity,
			entityAdmins: entity.entityAdmins.filter((admin) => !users.some((user) => user.userId === admin.userId))
		}));
	}
	return updatedEntityList;
};

//this function adds to the admin into entityAdmins property of the entity
const addUsersAsEntityAdmin = (entityList, users, entityData) => {
	return entityList.map((entity) => {
		let entityAdmins = [...entity.entityAdmins];

		const updatedContacts = entity.contacts.map((contact) => {
			const user = users.find((user) => user.userId === contact.userId);

			if (user && entity.entityId === entityData.entityId) {
				const isAlreadyAdmin = entityAdmins.some((admin) => admin.userId === user.userId);

				if (!isAlreadyAdmin && entity.entityId === entityData.entityId && entityData.operation) {
					entityAdmins = [...entityAdmins, user];
				}

				return {...contact, ...contact, isEntityAdmin: true};
			} else {
				return contact;
			}
		});

		return {
			...entity,
			contacts: updatedContacts,
			entityAdmins: entityAdmins
		};
	});
};

const handleViewOperation = (entityList, users, viewData) =>
	entityList.map((entity) => {
		return {
			...entity,
			contacts: entity.contacts.map((contact) => {
				if (users.some((user) => user.userId === contact.userId)) {
					let newViews = [...contact.dashboard];
					viewData.forEach(({view, operation}) => {
						newViews = newViews.filter((i) => i !== view);
						if (operation) newViews = [...newViews, view];
					});
					return {...contact, dashboard: newViews};
				}
				return {...contact};
			})
		};
	});

const handleHasAccess = (entityList, users, clAccess) =>
	entityList.map((entity) => {
		return {
			...entity,
			contacts: entity.contacts.map((contact) => {
				if (users.some((user) => user.userId === contact.userId)) {
					return {...contact, contactList: {hasAccess: clAccess}};
				}
				return {...contact};
			})
		};
	});

const handleGroupRiskAssessment = (entityList, users, graAccess) =>
	entityList.map((entity) => {
		return {
			...entity,
			contacts: entity.contacts.map((contact) => {
				if (users.some((user) => user.userId === contact.userId)) {
					return {...contact, groupRiskAssessment: {hasAccess: graAccess}};
				}
				return {...contact};
			})
		};
	});

export default ({users, entityList, entityData = null, viewData, clAccess, graAccess, userLevelAccess}) => {
	let newEntityList = [...entityList];
	if (entityData !== null) newEntityList = handleEntityOperation(users, newEntityList, entityData, userLevelAccess);
	if (viewData.length > 0) newEntityList = handleViewOperation(newEntityList, users, viewData);
	if (clAccess !== undefined) newEntityList = handleHasAccess(newEntityList, users, clAccess);
	if (graAccess !== undefined) newEntityList = handleGroupRiskAssessment(newEntityList, users, graAccess);
	if (userLevelAccess === entityAdmin) newEntityList = addUsersAsEntityAdmin(newEntityList, users, entityData);
	return newEntityList;
};
